import { getUserDisplayPermissions } from '../../reducers';
import { compose, branch, renderComponent } from 'recompose';
import { connect } from 'react-redux';

import Dashboard from '../dashboard';
import Calendar from '../calendar';

const mapStateToProps = state => ({
    userPermissions: getUserDisplayPermissions(state)
});

const bindState = connect(mapStateToProps);

const dashboardIfAuthorized = branch(({ userPermissions }) => {
    return userPermissions.landing === 'dashboard';
}, renderComponent(Dashboard));

export default compose(bindState, dashboardIfAuthorized)(Calendar);



// WEBPACK FOOTER //
// ./src/containers/homepage/index.js